import { reverseIndex } from '../state/collection';
export var getStarlingKey = function (text) {
    if (reverseIndex[text] && reverseIndex[text].size === 1) {
        var _a = Array.from(reverseIndex[text])[0].split('@'), lang = _a[0], key = _a[1];
        return {
            lang: lang,
            key: key,
        };
    }
    return undefined;
};
